import { ScheduledMeetingResponse } from "../../calendly/ScheduledMeetingResponse";
import { Gender } from "../../enums/enums";
import { StudentMentorRequestStatus } from "../../enums/studentMentorRequestStatus";

export interface StudentMentorResponse {
    studentId: string;
    gender: Gender;
    mentorId: string;
    firstName: string;
    lastName: string;
    isGraduate: boolean;
    graduationCollageName: string;
    isMasters: boolean;
    mastersCollageName: string;
    imageUrl?: string;
    meetings: ScheduledMeetingResponse[];
    status?: StudentMentorRequestStatus;
    purposeToConnect?: string | null;
    calendlyInvitation?: CalendlyInvitation
}

export enum CalendlyInvitation
{
    Invited,
    Accepted
}

